import {
    type CollectivesShareClassMeta,
    type ShareClassDataWithType,
} from "@hsl/fund-explorer/metaSchemas";

/***
 *
 * SHARE CLASS GROUPINGS / ORDER TO COME FROM API
 *
 */

function addGroupToShareClasses(
    shareclasses: ShareClassDataWithType[],
): (ShareClassDataWithType & { group: string })[] {
    return shareclasses.map((shareclass) => {
        const { shortName } = shareclass.data.data as CollectivesShareClassMeta;
        const group = shortName ? shortName.slice(0, 1).toUpperCase() : "";
        return {
            ...shareclass,
            group,
        };
    });
}

type WithGroup = { group: string };
function groupShareClasses(
    data: ShareClassDataWithType[],
    key?: string,
    flip = false,
    ordering: string[] = [],
) {
    const aSort = (a: WithGroup, b: WithGroup) => {
        const preOrderIdx = (x: WithGroup) =>
            ordering.findIndex(
                (o) => o.toLowerCase() === x.group.toLowerCase(),
            );
        const preOrderA = preOrderIdx(a);
        const preOrderB = preOrderIdx(b);
        if (preOrderA > -1 || preOrderB > -1) {
            return preOrderA > preOrderB ? -1 : 1;
        }
        return a.group < b.group ? -1 : 1;
    };
    const dSort = (a: WithGroup, b: WithGroup) => aSort(a, b) * -1;
    const dataWithGroups = (
        key
            ? data.map((d) => ({ ...d, group: d.data.data[key] ?? "" }))
            : addGroupToShareClasses(data)
    ).sort(flip ? dSort : aSort);
    const output: Record<
        string,
        (ShareClassDataWithType & { group: string })[]
    > = Object.fromEntries(dataWithGroups.map((share) => [share.group, []]));
    dataWithGroups.forEach((share) => {
        // @ts-expect-error idk
        output[share.group] = [...output[share.group], share];
    });
    return output;
}

export default groupShareClasses;
